// extracted by mini-css-extract-plugin
var _1 = "SliderElement_isV2__e99d1";
var _2 = "SliderElement_pdfContainer__e14cb";
var _3 = "SliderElement_root__9caf1";
var _4 = "SliderElement_slideArrow__0a1a7";
export { _1 as "isV2", _2 as "pdfContainer", _3 as "root", _4 as "slideArrow" }
